import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { api } from 'src/api';
const NO_OPTIONS = {
  cancelToken: undefined
};

// The customer's account setup fee price for a property, or null when the feature is off, the product is
// not on the property's subscription, or the lookup fails — every null hides the setup fee fields.
export const useAccountSetupFeePrice = _ref => {
  let propertyId = _ref.propertyId,
    isEnabled = _ref.isEnabled;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    price = _useState2[0],
    setPrice = _useState2[1];
  useEffect(() => {
    setPrice(null);
    if (!isEnabled || !propertyId) return undefined;
    let isCurrent = true;
    api.Payment.getAccountSetupFeePrice({
      propertyId
    }, NO_OPTIONS).then(resp => {
      var _resp$response$price, _resp$response;
      if (isCurrent) setPrice(resp !== null && resp !== void 0 && resp.isSuccessful ? (_resp$response$price = (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.price) !== null && _resp$response$price !== void 0 ? _resp$response$price : null : null);
    }).catch(() => {});
    return () => {
      isCurrent = false;
    };
  }, [propertyId, isEnabled]);
  return price;
};